var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-512.8 267.1 26.7 27",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#424D56",
    d: "M-503.9 270.4c.9-2.2 2.5-3.3 4.4-3.3 2 0 3.8 1.3 4.6 3.8.3.9.5 2.4.5 3.5 0 4-2.3 7.3-5.1 7.3s-5.1-3.3-5.1-7.3c.1-1.3.3-2.9.7-4zm17.9 21.9c-.1-1.7-1-7.9-2.3-8.5-2.6-1.3-6.9-1.9-7.7-1.8 0 0-.1.1-.2.1-.7.3-1.9.5-3.1.5h-.2c-1.2 0-2.4-.2-3.1-.5-.1 0-.1-.1-.2-.1-.9-.1-5.1.6-7.7 1.8-1.3.7-2.2 6.8-2.3 8.5-.1 1.1 4.5 1.6 8.4 1.7l5.1.1s4.8-.1 4.7-.1c4-.2 8.7-.6 8.6-1.7z"
  })));
}

export default SvgCustomer;